
var product = {
    // NZP-6: Display any NZ pricing on page (used in header/js/globals.js)
    displayPricing: function(currency){
        //Note that currency is user editable (a cookie) so for safety's sake should be escaped. But the version of JQuery on prod doesn't have this function..
        // const clsCurr = 'product-cost--' + $.escapeSelector(currency.toLowerCase()); 
        const clsCurr = 'product-cost--' + currency.toLowerCase();
        // display correct currency in product details page
        $('.product-cost').each(function(){
            if ($(this).hasClass(clsCurr)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
        // display correct currency in other formats
        $('.button .price').each(function(){
            if ($(this).hasClass(clsCurr)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    }
};

(function($){
    'use strict';

    var $slideshow = $('.slick-related');

    var settings = {
        dots:           true,
        arrows:         true,
        speed:          400,
        slide:          '.slick-related__slide',
        slidesToShow:   6,
        infinite:       true,
        slidesToScroll: 6,

        responsive: [{

            breakpoint: 1025,
            
            settings: { 
                slidesToShow:   5,
                infinite:       true,
                slidesToScroll: 5,
            }

        }, {

            breakpoint: 769,
        
            settings: {
                slidesToShow:   4,
                infinite:       true,
                slidesToScroll: 4,
            }

        }, {

            breakpoint: 323,
            
            settings: {
                slidesToShow:   2,
                infinite:       true,
                slidesToScroll: 2,
            }

        }]               
    };
   

    $slideshow.slick(settings);
    $slideshow.find('.slick-dots').css('margin-left', '-' + $slideshow.find('.slick-dots').width()/2 + 'px');

    
/*  
    var resizeId;
    // reslick only if it's not slick()
    $(window).on('load resize', function() {
        clearTimeout(resizeId);
        resizeId = setTimeout(function() {

            if ($(document).width() > 1024) {
                $slideshow.addClass('row');
                if ($slideshow.hasClass('slick-initialized')) {      
                    $slideshow.slick('unslick');
                }
            } else {
                $slideshow.removeClass('row');
                if (!$slideshow.hasClass('slick-initialized')) {      
                    $slideshow.slick(settings);

                }
            }

        }, 300);
    });
*/



    $('.print').on('click', function() {
        window.print();
    });




}(jQuery));